import UsersService from "@velocity-ehs/user-utils-module";
import React from "react";
import { useTranslation } from "react-i18next";
import velocityAccelerateLogo from "../../../assets/images/accelerate-logo-black.svg";
import SolutionTile from "./SolutionTile";
import classes from "./SolutionsHome.module.scss";

const SolutionsHome: React.FC = () => {
  const { t } = useTranslation();

  const tiles = UsersService.user.assignedSolutions.filter(
    (sol) => sol.code !== "PLATFORM"
  );

  return (
    <div className={classes.homeContainer}>
      <h1 className={classes.welcomeTo}>{t("homepage_welcome_to")}</h1>
      <div className={classes.homePageLogo}>
        <img
          title="Velocity EHS"
          src={velocityAccelerateLogo}
          alt="Velocity EHS"
        />
      </div>
      <div className={classes.tileGridContainer}>
        {UsersService.isUserCustomerActive() &&
          tiles.map((tile) => {
            return <SolutionTile key={tile.code} solution={tile} />;
          })}
      </div>
      <h1 className={classes.bottomText}>
        {t("homepage_accelerate_performance_message")}
      </h1>
    </div>
  );
};

export default SolutionsHome;
